import styled from 'styled-components';

export const StyledControlBarButton = styled.button.attrs({
  type: 'button',
})`
  appearance: none;
  background: transparent;
  border: 0;
  color: ${props =>
    props.isActive
      ? props.theme.themeColors.controlBar.leftPanel.buttonColorOnActive
      : props.theme.themeColors.controlBar.leftPanel.buttonColor};
  cursor: pointer;
  display: flex;
  font-family: inherit;
  font-size: 1rem;
  font-weight: ${props => (props.isActive ? '500' : 'normal')};
  margin: 0;
  text-align: center;
  padding: 16px 0px;
  width: 100%;
  justify-content: center;
  &:hover {
    color: ${props =>
      props.theme.themeColors.controlBar.leftPanel.buttonColorOnHover};
  }
`;
